import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { formPrefixCls } from "@/base/components/form/Form.component";
import { ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Form">> = ({
  labelFontWeight,
  fontFamily,
  labelRequiredMarkColor,
}: any) => ({
  [`.${formPrefixCls}-item`]: {
    [`&:last-child`]: {
      marginBottom: 0,
    },
    [`.${formPrefixCls}-required-mark`]: {
      color: labelRequiredMarkColor,
    },
    [`label`]: {
      fontWeight: `${labelFontWeight}`,
      fontFamily: `${fontFamily}`,
      gap: "4px",

      [`&:after`]: {
        display: "none",
      },
      [`.${ICON_PREFIX}`]: {
        verticalAlign: `-0.25em`,
      },
    },
  },
});

export const useFormStyle = genComponentStyleHook(["Form", "cso"], (token) => {
  return [genStyle(token)];
});
